import { attrAccept } from "./attrAccept.js";
const resolveAcceptingSingleKind = async (fileOptions, fileKind) => {
  const acceptMimeTypes = fileKind.acceptMimeTypes;
  if (!attrAccept(fileOptions.file, acceptMimeTypes)) {
    return void 0;
  }
  const isFileAccepted = fileKind.acceptFile === void 0 ? true : await fileKind.acceptFile(fileOptions);
  if (!isFileAccepted) {
    return void 0;
  }
  return isFileAccepted;
};
export {
  resolveAcceptingSingleKind
};
//# sourceMappingURL=resolveAccept.js.map
